/*
  Rotates announcement messages. Pauses on hover and focus, and stays put
  entirely when the visitor asked for reduced motion — a message that
  disappears mid-read is an accessibility problem, not a flourish.
*/
class AmvAnnounce {
  constructor(root) {
    this.root = root;
    this.items = Array.from(root.querySelectorAll('.amv-announce__item'));
    if (this.items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.index = 0;
    this.delay = (parseInt(root.dataset.rotate, 10) || 5) * 1000;
    this.timer = null;

    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    root.addEventListener('focusin', () => this.stop());
    root.addEventListener('focusout', () => this.start());
    document.addEventListener('visibilitychange', () =>
      document.hidden ? this.stop() : this.start()
    );

    this.start();
  }

  start() {
    this.stop();
    this.timer = window.setInterval(() => this.next(), this.delay);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    this.items[this.index].hidden = true;
    this.items[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index].hidden = false;
    this.items[this.index].classList.add('is-active');
  }
}

document.querySelectorAll('.amv-announce[data-rotate]').forEach((el) => new AmvAnnounce(el));
